import { modalVariants } from "../../../Utils/constants";
import { Phone, Mail, ChevronRight } from "../../../Assets/Icons";
import CloseButton from "../../../Components/Buttons/close-button";
import { useModalContext } from "../../../Contexts/ModalContext";

import "./contact-support-modal.scss";

export default function renderContactSupportModal(modalContext) {
  const { updateModalComponent, setModalTitle, setModalVariant, setModalClassName } = modalContext;

  updateModalComponent(ContactSupportModal);
  setModalVariant(modalVariants.formDialog);
  setModalTitle("Contact Support");
  setModalClassName("contact-support-modal hide-header");
}

const ContactSupportModal = () => {
  const { onModalClose } = useModalContext();

  return (
    <div className="csm-content">
      <div className="csm-header">
        <div className="csm-header-text">
          <h3 className="csm-title">Contact Support</h3>
          <p className="csm-description">
            For help with your utilities setup, reach out to MyUtilities support using the options below.
          </p>
        </div>
        <CloseButton onClick={onModalClose} className="csm-close" />
      </div>
      <a href="tel:+18885544609" className="contact-option-card">
        <Phone />
        <div className="details">
          <span className="label">Phone</span>
          <span className="value">888-554-4609</span>
        </div>
        <div className="chevron">
          <ChevronRight />
        </div>
      </a>
      <a href="mailto:support@myutilities.com" className="contact-option-card">
        <Mail />
        <div className="details">
          <span className="label">Email</span>
          <span className="value">support@myutilities.com</span>
        </div>
        <div className="chevron">
          <ChevronRight />
        </div>
      </a>
    </div>
  );
};
